import React from "react";
import { useFormContext } from "react-hook-form";
import { htmlToText } from "html-to-text";
import { FaLink, FaFacebook, FaXTwitter, FaInstagram, FaVideo, FaMap } from "react-icons/fa6";

const ProviderLinks = ({ isPremium, setPremiumChangesMade }) => {
  const { register, watch } = useFormContext();

  return (
    <div className="provider-section">
      <h3>Company Information</h3>

      {/* Company Website */}
      <div className="font-semibold">Link to Company Website:</div>
      <div className="grid grid-cols-1 items-center gap-2">
        <div className="flex items-center">
          <FaLink className="mr-2 text-primaryBlue" />
          <input type="text" {...register("premium.company_website")} className="w-full" onChange={() => setPremiumChangesMade(true)} />
        </div>
      </div>

      {/* Social Media Links */}
      <div className="font-semibold">Social Media Links:</div>
      <div className="grid grid-cols-1 items-center gap-2">
        {/* Facebook */}
        <div className="flex items-center">
          <FaFacebook className="mr-2 text-primaryBlue" />
          <input type="text" {...register("premium.company_facebook")} className="w-full" onChange={() => setPremiumChangesMade(true)} />
        </div>

        {/* Twitter */}
        <div className="flex items-center">
          <FaXTwitter className="mr-2 text-primaryBlue" />
          <input type="text" {...register("premium.company_twitter")} className="w-full" onChange={() => setPremiumChangesMade(true)} />
        </div>

        {/* Instagram */}
        <div className="flex items-center">
          <FaInstagram className="mr-2 text-primaryBlue" />
          <input type="text" {...register("premium.company_instagram")} className="w-full" onChange={() => setPremiumChangesMade(true)} />
        </div>
      </div>

      {/* Company Video */}
      <div className="font-semibold">Company Video Link:</div>
      <div className="grid grid-cols-1 items-center gap-2">
        <div className="flex items-center">
          <FaVideo className="mr-2 text-primaryBlue" />
          <input type="text" {...register("premium.company_video")} className="w-full" onChange={() => setPremiumChangesMade(true)} />
        </div>
      </div>

      {/* Virtual Tour */}
      <div className="font-semibold">Virtual Tour:</div>
      <div className="grid grid-cols-1 items-center gap-2">
        <div className="flex items-center">
          <FaMap className="mr-2 text-primaryBlue" />
          <input type="text" {...register("premium.company_tour")} className="w-full" onChange={() => setPremiumChangesMade(true)} />
        </div>
      </div>
    </div>
  );
};

export default ProviderLinks;
